"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.siteAddApi = siteAddApi;
exports.siteApproveApi = siteApproveApi;
exports.siteBuildListApi = siteBuildListApi;
exports.siteChangeApi = siteChangeApi;
exports.siteCloneApi = siteCloneApi;
exports.siteCopyUrlApi = siteCopyUrlApi;
exports.siteDeleteApi = siteDeleteApi;
exports.siteDownloadUrlApi = siteDownloadUrlApi;
exports.siteEditApi = siteEditApi;
exports.siteEditSaveApi = siteEditSaveApi;
exports.siteEditorLockApi = siteEditorLockApi;
exports.siteEditorUnlockApi = siteEditorUnlockApi;
exports.siteFilterApi = siteFilterApi;
exports.siteListApi = siteListApi;
exports.siteLockApi = siteLockApi;
exports.sitePauseApi = sitePauseApi;
exports.sitePlayApi = sitePlayApi;
exports.siteReadApi = siteReadApi;
exports.siteSaveApi = siteSaveApi;
exports.siteSoftDeleteApi = siteSoftDeleteApi;
exports.siteSoftDeleteListApi = siteSoftDeleteListApi;
exports.siteSoftDeleteRestoreApi = siteSoftDeleteRestoreApi;
exports.siteSubmitApi = siteSubmitApi;
exports.siteUnlockApi = siteUnlockApi;
exports.siteUpdateApi = siteUpdateApi;
exports.siteViewConfigApi = siteViewConfigApi;
exports.siteViewEditorListApi = siteViewEditorListApi;
exports.siteViewSnapshotsApi = siteViewSnapshotsApi;
var _core = require("../../../core/core.service");
var _app = _interopRequireDefault(require("../../../../configs/app.config"));
var _dashboard = require("../../../../constants/endpoints/dashboard");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
// @flow

var api = new _core.APICore();

/**
 * controller site add
 * @param payload
 * @returns api response
 * @description this function used to controller site add.
 */
function siteAddApi(params) {
  return api.create("".concat(_app.default.baseUrl + _dashboard.SiteService.site.add), params);
}

/**
 * controller site edit
 * @param payload
 * @returns api response
 * @description this function used to controller site edit.
 */
function siteEditSaveApi(params) {
  return api.update("".concat(_app.default.baseUrl + _dashboard.SiteService.site.edit), params);
}

/**
 * controller site lock
 * @param payload
 * @returns api response
 * @description this function used to controller site lock.
 */
function siteEditorLockApi(params) {
  var headersConfig = JSON.parse(sessionStorage.getItem("headersConfigReport")) || {
    headers: {
      referrer: window.location.origin + "/platform/site-edit",
      originReferer: window.location.origin + "/platform"
    }
  };
  return api.update("".concat(_app.default.baseUrl + _dashboard.SiteService.siteEditor.lock), params, headersConfig);
}

/**
 * controller site unlock
 * @param payload
 * @returns api response
 * @description this function used to controller site unlock.
 */
function siteEditorUnlockApi(params) {
  var headersConfig = JSON.parse(sessionStorage.getItem("headersConfigReport")) || {
    headers: {
      referrer: window.location.origin + "/platform/site-edit",
      originReferer: window.location.origin + "/platform"
    }
  };
  return api.update("".concat(_app.default.baseUrl + _dashboard.SiteService.siteEditor.unlock), params, headersConfig);
}

/**
 * controller site edit
 * @param payload
 * @returns api response
 * @description this function used to controller site edit.
 */
function siteEditApi(params) {
  var _sessionStorage;
  var headersConfig = (JSON === null || JSON === void 0 ? void 0 : JSON.parse((_sessionStorage = sessionStorage) === null || _sessionStorage === void 0 ? void 0 : _sessionStorage.getItem("headersConfigSite"))) || {
    headers: {
      referrer: window.location.origin + "/platform/site-edit",
      originReferer: window.location.origin + "/platform"
    }
  };
  return api.get("".concat(_app.default.baseUrl + _dashboard.SiteService.site.edit), params, headersConfig);
}

/**
 * controller site read
 * @param payload
 * @returns api response
 * @description this function used to controller site read.
 */
function siteReadApi(params) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.SiteService.site.read), params);
}

/**
 * controller site change
 * @param payload
 * @returns api response
 * @description this function used to controller site change.
 */
function siteChangeApi(params) {
  return api.update("".concat(_app.default.baseUrl + _dashboard.SiteService.site.change), params);
}

/**
 * controller site update
 * @param payload
 * @returns api response
 * @description this function used to controller site update.
 */
function siteUpdateApi(params) {
  return api.update("".concat(_app.default.baseUrl + _dashboard.SiteService.site.update), params);
}

/**
 * controller list sites
 * @param payload
 * @returns api response
 * @description this function used to bulk controller list sites.
 */
function siteListApi(params) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.SiteService.site.list), params);
}

/**
 * controller site submit
 * @param payload
 * @returns api response
 * @description this function used to controller site submit.
 */
function siteSubmitApi(params) {
  return api.update("".concat(_app.default.baseUrl + _dashboard.SiteService.site.submit), params);
}

/**
 * controller site approve
 * @param payload
 * @returns api response
 * @description this function used to controller site approve.
 */
function siteApproveApi(params) {
  return api.update("".concat(_app.default.baseUrl + _dashboard.SiteService.site.approve), params);
}

/**
 * controller site delete
 * @param payload
 * @returns api response
 * @description this function used to controller site delete.
 */
function siteDeleteApi(params) {
  return api.delete("".concat(_app.default.baseUrl + _dashboard.SiteService.site.delete), params);
}

/**
 * controller site clone
 * @param payload
 * @returns api response
 * @description this function used to controller site clone.
 */
function siteCloneApi(params) {
  return api.create("".concat(_app.default.baseUrl + _dashboard.SiteService.site.clone), params);
}

/**
 * controller site save
 * @param payload
 * @returns api response
 * @description this function used to controller site save.
 */
function siteSaveApi(params) {
  return api.create("".concat(_app.default.baseUrl + _dashboard.SiteService.site.save), params);
}

/**
 * controller site build list
 * @param payload
 * @returns api response
 * @description this function used to controller site build list.
 */
function siteBuildListApi(params) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.SiteService.site.buildList), params);
}

// apis not available for below

/**
 * controller site update
 * @param payload
 * @returns api response
 * @description this function used to controller site update.
 */
function siteFilterApi(params) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.SiteService.site.filter), params);
}

/**
 * controller list sites
 * @param payload
 * @returns api response
 * @description this function used to bulk controller list sites.
 */
function sitePauseApi(params) {
  return api.update("".concat(_app.default.baseUrl + _dashboard.SiteService.site.pause), params);
}

/**
 * controller site submit
 * @param payload
 * @returns api response
 * @description this function used to controller site submit.
 */
function sitePlayApi(params) {
  return api.update("".concat(_app.default.baseUrl + _dashboard.SiteService.site.play), params);
}

/**
 * controller site approve
 * @param payload
 * @returns api response
 * @description this function used to controller site approve.
 */
function siteCopyUrlApi(params) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.SiteService.site.copyUrl), params);
}

/**
 * controller site delete
 * @param payload
 * @returns api response
 * @description this function used to controller site delete.
 */
function siteDownloadUrlApi(params) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.SiteService.site.downloadEmail), params);
}

/**
 * controller site save
 * @param payload
 * @returns api response
 * @description this function used to controller site save.
 */
function siteLockApi(params) {
  var _sessionStorage2;
  var headersConfig = JSON === null || JSON === void 0 ? void 0 : JSON.parse((_sessionStorage2 = sessionStorage) === null || _sessionStorage2 === void 0 ? void 0 : _sessionStorage2.getItem("headersConfigLock"));
  return api.update("".concat(_app.default.baseUrl + _dashboard.SiteService.site.lock), params, headersConfig);
}

/**
 * controller site build list
 * @param payload
 * @returns api response
 * @description this function used to controller site build list.
 */
function siteUnlockApi(params) {
  var _sessionStorage3;
  var headersConfig = JSON === null || JSON === void 0 ? void 0 : JSON.parse((_sessionStorage3 = sessionStorage) === null || _sessionStorage3 === void 0 ? void 0 : _sessionStorage3.getItem("headersConfigUnlock"));
  return api.update("".concat(_app.default.baseUrl + _dashboard.SiteService.site.unlock), params, headersConfig);
}

/**
 * controller site delete
 * @param payload
 * @returns api response
 * @description this function used to controller site delete.
 */
function siteViewSnapshotsApi(params) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.SiteService.site.viewSnapshots), params);
}

/**
 * controller site save
 * @param payload
 * @returns api response
 * @description this function used to controller site save.
 */
function siteViewEditorListApi(params) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.SiteService.site.viewEditorList), params);
}

/**
 * controller site build list
 * @param payload
 * @returns api response
 * @description this function used to controller site build list.
 */
function siteViewConfigApi(params) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.SiteService.site.viewConfig), params);
}

/**
 * controller site soft delete
 * @param payload
 * @returns api response
 * @description this function used to controller site soft delete.
 */
function siteSoftDeleteApi(params) {
  return api.delete("".concat(_app.default.baseUrl + _dashboard.SiteService.site.softDelete), params);
}

/**
 * controller site soft delete list
 * @param payload
 * @returns api response
 * @description this function used to controller site soft delete list.
 */
function siteSoftDeleteListApi(params) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.SiteService.site.softDeleteList), params);
}

/**
 * controller site soft delete restore
 * @param payload
 * @returns api response
 * @description this function used to controller site soft delete restore.
 */
function siteSoftDeleteRestoreApi(params) {
  return api.update("".concat(_app.default.baseUrl + _dashboard.SiteService.site.softDeleteRestore), params);
}